import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTabGroup} from '@angular/material/tabs';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-driving-school-my-earnings',
  templateUrl: './driving-school-my-earnings.component.html',
  styleUrls: ['./driving-school-my-earnings.component.scss']
})
export class DrivingSchoolMyEarningsComponent implements OnInit {

  selectedIndex: any;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    let queryParams = this.route.snapshot.queryParams;
    if (queryParams.isDownloads) {
      this.selectedIndex = 0;
    }
    if (queryParams.isCommissions) {
      this.selectedIndex = 1;
    }
  }

}
